export default {
    toneTypes: ["professional", "inviting", "informative", "descriptive", "persuasive"]
}
